const schema = localStorage.getItem("schema");
export const basicFormData = () => ({
  inputData: {
    material_id: "",
    quantity: "",
    created_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "inverts",
    schema: schema,
    include: [
      { model: "material_masters", as: "material" }
    ]
  };

  const navigatePage = { back: "/spare-part-inventory-list" };

  const headerName = "Spare Part Inventory";

  const validationType = "SparePartInventoryCreate";
  const endpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";
  
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    endpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "inverts",
    schema: schema,   
    include: [
      {model:"material_masters", as:"material"}
    ]
  };

  
  const navigatePage = {
    create: "/spare-part-inventory-create",
    edit: "/spare-part-inventory-create",
    view: "/spare-part-inventory-view",
  };

  const searchfields = [
    "material.name",
  ];

  const headerName = "Spare Part Inventory";
  const endpoint = "/getRecords";
  const exportFileName = "SparePartInventoryData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "city_masters",
  schema: schema,
  include: [
    { module: "country_masters", moduleAs: "country" },
    { module: "state_masters", moduleAs: "state" },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
